
<template>
  <!--新增物业-->
  <x-addEdit
    :formList="formList"
    :formKey="formKey"
    :addParam="addParam"
    :editParam="editParam"
    :detailParam="detailParam"
  >
  </x-addEdit>
</template>

<script>
export default {
  name: 'addProperty',
  data () {
    let decoratorOptions = {
      role_name: {
        validateTrigger: 'blur',
        rules: [
          { required: true, message: '请输入角色名' },
          { min: 2, max: 10, message: '角色名长度为2-10位字' }
        ]
      },
      intro: {
        validateTrigger: 'blur',
        rules: [{ min: 2, max: 20, message: '描述长度为2-20位字' }]
      }
    };
    return {
      formKey: {
        role_name: '',
        intro: ''
      },
      formList: [
        {
          label: '角色名',
          inputType: 'input',
          options: [],
          placeholder: '请输入角色名',
          props: ['role_name', decoratorOptions.role_name]
        },
        {
          label: '角色描述',
          inputType: 'input',
          options: [],
          placeholder: '请输入角色描述',
          props: ['intro', decoratorOptions.intro]
        }
      ],
      addParam: {
        url: '/property/role',
        reqHandle: '', // this.reqHandle
        resHandle: '' // this.addResHandle
      },
      detailParam: {
        url: '/property/role/',
        resHandle: '' // this.detailResHandle
      },
      editParam: {
        url: '/property/role/',
        resHandle: '' // this.editResHandle
      }
    };
  },
  computed: {
  },
  mounted () {},
  methods: {
    detailResHandle (res) {
      return res;
    },
    reqHandle (param) {
      return param;
    },
    addResHandle (res) {
      return res;
    },
    editResHandle (res) {
      return res;
    }
  }
};
</script>
